"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const serverSchema = new mongoose_1.Schema({
    name: {
        type: String,
        required: true,
    },
    url: String,
    grpc_address: String,
    userId: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
        required: true,
    },
    teamId: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Team",
        required: false,
    },
    domain: {
        required: false,
        type: String,
    },
    webhook_url: String,
    ip_address: {
        type: String,
        required: true,
    },
    ipv6: String,
    private_ip_address: {
        type: String,
        required: true,
    },
    tunnel_token: {
        type: String,
        required: false,
    },
    type: String,
    status: {
        type: String,
        enum: Object.values(enum_1.SERVER_STATUS),
        default: enum_1.SERVER_STATUS.Active,
    },
    default: Boolean,
    is_custom_provision: {
        type: Boolean,
        default: true,
    },
    region: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Region",
        required: true,
    },
    tag: String,
    firewall_id: {
        required: false,
        type: String,
    },
    specifications: {
        type: Object,
        default: {},
        select: true,
    },
    meta: {
        type: Object,
        default: {},
        select: true,
    },
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("Server", serverSchema);
